import { useToast } from '@chakra-ui/react';
import { useCallback } from 'react';

import { useSubmitMarketplaceSelfServePayoffMutation } from '../../../../../gql/generated/graphql';
import { trackPayoffSelfServeModalSubmitted } from '../../../../../services/analytics/marketplaceEvents';
import { logger } from '../../../../../services/sentry';
import { createErrorToast } from '../../../../../utils/toast';

type SelfServePayoffValues = {
  vehiclePayoff: number;
  goodThroughDate: Date;
};

const useSelfServePayoffSubmit = (dealId: string) => {
  const [submitSelfServePayoff] = useSubmitMarketplaceSelfServePayoffMutation();
  const toast = useToast();

  return useCallback(
    async ({ vehiclePayoff, goodThroughDate }: SelfServePayoffValues): Promise<boolean> => {
      trackPayoffSelfServeModalSubmitted(dealId, vehiclePayoff);
      try {
        await submitSelfServePayoff({
          variables: { dealId, vehiclePayoff, goodThroughDate },
        });
        return true;
      } catch (err) {
        logger.error(
          'useSelfServePayoffSubmit',
          'submitMarketplaceSelfServePayoff failed',
          { dealId },
          err,
        );
        toast(
          createErrorToast({
            errorMessage:
              err instanceof Error && err.message
                ? err.message
                : "Couldn't save your payoff. Please try again.",
          }),
        );
        return false;
      }
    },
    [dealId, submitSelfServePayoff, toast],
  );
};

export default useSelfServePayoffSubmit;
